export default __webpack_public_path__ + "8959a0b75e70e3d60ceab4f7e370b1f2.png";